/**
 * REDUX CONSTANTS
 * Redux action types used in payments-js must be namespaced as they may clash
 * with other action types used throughout the host app (renter-hub-web).
 */

const getRenterRequestActionTypes = (requestName: string) => ({
  INIT: `PAYMENTS/RENTER/${requestName}_INIT`,
  SUCCESS: `PAYMENTS/RENTER/${requestName}_SUCCESS`,
  FAIL: `PAYMENTS/RENTER/${requestName}_FAIL`,
});

// request action types
export const REQUEST_USER_API = getRenterRequestActionTypes('REQUEST_USER_API');
export const REQUEST_RENTER_STATUS = getRenterRequestActionTypes('REQUEST_RENTER_STATUS');
export const REQUEST_CREATE_PAYMENT_METHOD = getRenterRequestActionTypes('REQUEST_CREATE_PAYMENT_METHOD');
export const REQUEST_RENT_DETAILS = getRenterRequestActionTypes('REQUEST_RENT_DETAILS');

export const REQUEST_PAY_ONE_TIME_PAYMENT = getRenterRequestActionTypes('REQUEST_PAY_ONE_TIME_PAYMENT');
export const REQUEST_MARK_ACKNOWLEDGED = getRenterRequestActionTypes('REQUEST_MARK_ACKNOWLEDGED');
export const REQUEST_LINK_TOKEN = getRenterRequestActionTypes('REQUEST_LINK_TOKEN');
export const REQUEST_UPDATE_MODE_LINK_TOKEN = getRenterRequestActionTypes('REQUEST_UPDATE_MODE_LINK_TOKEN');

export const REQUEST_PAYMENT_REPORTING_OPT_IN = getRenterRequestActionTypes('REQUEST_PAYMENT_REPORTING_OPT_IN');
export const REQUEST_PAYMENT_REPORTING_OPT_OUT = getRenterRequestActionTypes('REQUEST_PAYMENT_REPORTING_OPT_OUT');
export const REQUEST_PAYMENT_REPORTING_STATUS = getRenterRequestActionTypes('REQUEST_PAYMENT_REPORTING_STATUS');
export const REQUEST_PAYMENT_REPORTING_STATUS_WITH_CREDIT_TRACKING = getRenterRequestActionTypes(
  'REQUEST_PAYMENT_REPORTING_STATUS_WITH_CREDIT_TRACKING',
);
export const REQUEST_PAYMENT_REPORTING_HISTORY = getRenterRequestActionTypes('REQUEST_PAYMENT_REPORTING_HISTORY');
export const REQUEST_ENROLL_RENTER_IN_CREDIT_TRACKING = getRenterRequestActionTypes(
  'REQUEST_ENROLL_RENTER_IN_CREDIT_TRACKING',
);
export const REQUEST_CREDIT_TRACKING_UNENROLL = getRenterRequestActionTypes('REQUEST_CREDIT_TRACKING_UNENROLL');

// non-request action types
export const SAVE_PAYMENT_INFO = 'PAYMENTS/RENTER/ONBOARDING/SAVE_PAYMENT_INFO';
export const EDIT_PAYMENT_INFO = 'PAYMENTS/RENTER/ONBOARDING/EDIT_PAYMENT_INFO';
export const SAVE_DATE_OF_BIRTH = 'PAYMENTS/RENTER/ONBOARDING/SAVE_DATE_OF_BIRTH';
export const SAVE_FIRST_NAME = 'PAYMENTS/RENTER/ONBOARDING/SAVE_FIRST_NAME';
export const SAVE_LAST_NAME = 'PAYMENTS/RENTER/ONBOARDING/SAVE_LAST_NAME';
export const IGNORE_RENT_AMOUNT_CHANGE = 'PAYMENTS/RENTER/DASHBOARD/IGNORE_RENT_AMOUNT_CHANGE';
export const SHOW_RENT_AMOUNT_CHANGE = 'PAYMENTS/RENTER/DASHBOARD/SHOW_RENT_AMOUNT_CHANGE';
export const UPDATE_ARRAY_USER_TOKEN = 'PAYMENTS/RENTER/DASHBOARD/UPDATE_ARRAY_USER_TOKEN';
export const UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS =
  'PAYMENTS/RENTER/DASHBOARD/UPDATE_CREDIT_TRACKING_ENROLLMENT_STATUS';
